export default "__VITE_ASSET__CdP9taOq__"